var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.9 207",
    style: {
      enableBackground: "new 0 0 210.9 207"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:url(#SVGID_1_);}\n\t.st2{display:inline;fill:#A93651;}\n\t.st3{display:inline;fill:url(#SVGID_00000151518599583561627770000017331314243234659495_);}\n\t.st4{display:inline;fill:url(#SVGID_00000124126320814760062540000016018447564425904256_);}\n\t.st5{display:inline;fill:url(#SVGID_00000042709476825699436060000008072849335420959423_);}\n\t.st6{display:inline;fill:url(#SVGID_00000011738056125786690520000001165104228429907630_);}\n\t.st7{display:inline;fill:#681642;}\n\t.st8{display:inline;fill:#AE4151;}\n\t.st9{display:inline;opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st10{display:inline;fill:url(#SVGID_00000134233466006645091550000012123656166631128760_);}\n\t.st11{display:inline;fill:url(#SVGID_00000103970963853864703630000001531245858617150848_);}\n\t.st12{fill:url(#SVGID_00000093158395232385464680000007226437522189483651_);}\n\t.st13{fill:url(#SVGID_00000062161339387918640470000016524371274447583648_);}\n\t.st14{fill:url(#SVGID_00000011025894506753479680000006283034355683030949_);}\n\t.st15{fill:url(#SVGID_00000044895317216442800120000012537265748390509212_);}\n\t.st16{fill:url(#SVGID_00000091012519109550209910000008433215430151650693_);}\n\t.st17{fill:url(#SVGID_00000070104886160713764520000013469393095495996035_);}\n\t.st18{fill:url(#SVGID_00000136407246228863209020000016838394149351251383_);}\n\t.st19{fill:url(#SVGID_00000029027846233086361810000007891791383717323194_);}\n\t.st20{fill:url(#SVGID_00000088109240272186417280000010980368138456880286_);}\n\t.st21{fill:url(#SVGID_00000156577224415143360880000006902130225310303134_);}\n\t.st22{fill:url(#SVGID_00000012470574939653144430000007789686161111335570_);}\n\t.st23{fill:#FFD9BB;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3012,
    y1: 152.6273,
    x2: 27.3012,
    y2: 205.7943,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.6,23c0,0-4.4-20.4-25.2-20.9C8.5,1.7,9.6,29.2,9.6,29.2l3.7-2.2c0,0-1.4-18.6,10.2-20.8 c11.6-2.3,21.1,4,21.1,4s-29.3-10.1-40,4.7S2.6,58.3,23.2,55C43.8,51.8,54.6,23,54.6,23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,31.4c0,0,24.6-23.1,49.6-6.8l2.1-0.7c0,0-23.5-18.1-51.3,1.1L0,31.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.6,16.4c0,0,28.2-14.1,49.2,1.6l-2-3.7c0,0-9.8-11.2-46.2,0.6L3.6,16.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.7,51.9c0,0-0.5-30.1,36.6-26L45,26.5c0,0-34.8-2-32.5,27.1L9.7,51.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167370098195111387730000003172426509853860742_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5069,
    y1: 158.433,
    x2: 183.5069,
    y2: 207.89,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000167370098195111387730000003172426509853860742_)"
    },
    d: "M156,24.6 c0,0,2.9-26.1,26.5-24.5c23.5,1.6,17.6,33.2,17.6,33.2s1.4-25.4-12.6-30.2s-21.6,3.8-21.6,3.8S180.8-2,200,8.3s12.9,42.8-15.8,41.2 L156,24.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150087108499822532670000009123753201732741261_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.6585,
    y1: 87.49,
    x2: 104.6585,
    y2: 191.4907,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000150087108499822532670000009123753201732741261_)"
    },
    d: "M176.1,120.4 c0,0-4-24.4-4.6-38.4c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1,0-0.1-0.1-0.1-0.1c-7-4.2-14.1-6.3-14.1-6.3S82,35.4,65,41.6c-2.7,1-5.2,2.3-7.3,3.8l0,0c-11.1,7.9-14.6,21.7-16.9,28.5 c-2.7,8.1,1.2,17.4-9.7,42.8c0,0-5.8-14.9-8.1-30.4c-2.2-14.7-2-39.7,8.1-50.9l0,0c0.5-0.6,1-1.1,1.6-1.6 C49,19.5,87.3,16.4,105.4,16.4s39.5-0.3,62.8,11.7c4.3,2.2,7.9,5.7,10.7,10C191.7,57.6,189.6,95.1,176.1,120.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052804830982881011020000013564188138580970655_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1496,
    y1: 0.89,
    x2: 24.1496,
    y2: 94.99,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000052804830982881011020000013564188138580970655_)"
    },
    d: "M31.3,116.7 c0,0-5.5,30.1-13.9,53.3s15.3,37,15.3,37S15,190.8,19.3,170.6s13.5-43.1,13.4-57.7L31.3,116.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070802033398504888870000018058250271183802254_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.7581,
    y1: 5.09,
    x2: 182.7581,
    y2: 88.99,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000070802033398504888870000018058250271183802254_)"
    },
    d: "M176.1,120.4 c0,0,2.7,8.5,8.3,37.3c5.7,28.8-5.7,45.1-5.7,45.1s11.2-12.2,10.7-31.5s-9.5-38.3-12.5-52.4L176.1,120.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.7,37.4c0,0-6-10.1-10.5-11.5S55.4,45.5,65.9,86.3c0,0-1.4-37.5,20.4-52.7c0,0,2.9,1.1,6.3,4 C92.6,37.6,97.2,37.8,97.7,37.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.4,43.6c0,0,19-0.1,28.6-10.4l4.1,5.2c0,0-3.9,10.3-26.2,9.8L146.4,43.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141,40.7c0,0,10.6-10.3,22.6-14.9l-2.8-1.2c0,0-10.7,3.8-20.9,15.6L141,40.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.4,43.3c0,0-9-6-17.6-16.3L42,27.8c0,0,3.6,10.7,18.4,16L61.4,43.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,63.5c0,0-12.2-2.2-18.9-18.1l-2.2,8.2c0,0,7.3,15.2,18.2,18.2L44.6,63.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.2,37.1c0,0,21.1-16.3,38.5-15.7l2,0.6c0,0-17.7-0.8-37.7,15.1H113.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.3,25.9c0,0,26.2,1.5,42.5,11.9l1.5-0.1c0,0-11.9-11.7-41.7-12.7L46.3,25.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.9,86.3c0,0,0.4-38.1,25.5-57.3l-8.5-8C82.9,20.9,53.7,37.2,65.9,86.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.8,45.4c-11.1,7.9-14.6,21.7-16.9,28.5c-2.7,8.1,1.2,17.4-9.7,42.8c0,0-5.8-14.9-8.1-30.4 c-2.2-14.7-2-39.7,8.1-50.9l0,0c0,0,7.3,14.4,11.5,15.5C46.7,52.1,57.2,45.8,57.8,45.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176.1,120.4c0,0-4-24.4-4.6-38.4c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1 c2.4,1.4,9.7,5.2,19.5,6c12,1,11.3-13.1,11.3-13.1l0.8,1C191.7,57.6,189.6,95.1,176.1,120.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.4,3.4c0,0,30.1,18,19.3,44.2l2.4-1.1c0,0,9.4-30.4-19.9-43.1C179.2,3.4,177.4,3.4,177.4,3.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.7,4c0,0,17.3,12,15.3,45.3l2.6-0.3c0,0,0.3-35-16.7-45H173.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.9,9.4c0,0,7.1,19.6-1,36c0,0,4.4-2.1,7.5-8.4c0,0,2.6-11.2,0.6-19.1C209.1,18,205.5,11.5,201.9,9.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171689098062155031060000013845350621702713476_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.2,
    y1: 158.49,
    x2: 170.2,
    y2: 185.0129,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000171689098062155031060000013845350621702713476_)"
    },
    d: "M156.3,22.9 c0,0,24.6-1.8,27.8,26.5C184.1,49.4,180.2,28.4,156.3,22.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041285530902937005100000008306979983397708449_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.7893,
    y1: 152.8421,
    x2: 38.7893,
    y2: 184.88,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000041285530902937005100000008306979983397708449_)"
    },
    d: "M54.6,23 c0,0-23.6,5.3-31.4,32C23.2,55,18.3,29.1,54.6,23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013880096090178075970000016196023573776180147_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.2814,
    y1: 101.99,
    x2: 166.2814,
    y2: 175.19,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013880096090178075970000016196023573776180147_)"
    },
    d: "M150.4,32.7l-1.7,4.4 c0,0,16.2,11.1,19.7,25.1s11.3,43.7,11.3,43.7s6.7-34.5,3.1-49.9C179.3,40.6,150.4,32.7,150.4,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025419058967410404160000013856148653435963573_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.6884,
    y1: 93.99,
    x2: 87.6884,
    y2: 206.2351,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025419058967410404160000013856148653435963573_)"
    },
    d: "M150.4,32.7l-4.8,3.5 c0,0-5.4,0.5-11.9,0.5s-43.4-0.4-43.4-0.4C78.8,51.1,81.6,85,81.6,85c-14.3-9.9-11.3-29-11.3-29s-19.4,22.5-21,29.8 c-1.5,7.1,9.4,15,10,15.5c-7.4-1.6-11.3-8-12.7-10.7l0,0c-0.4-0.7-0.6-1.2-0.6-1.2c0.1,1.7,0.4,3.2,0.8,4.6l0,0 c2,7.3,6.9,9.2,6.9,9.2c-3.8,0.6-7.6,0-10.8-1l0,0c0,0-0.1,0-0.2-0.1c-4.5-1.3-8-3.4-9.7-4.5c-0.4-0.2-0.7-0.4-1-0.6l0.1,16.9 c0,0-7.8-20.5-8-38.5l0,0c-0.1-4.5,0.3-8.9,1.4-12.7C31.2,43.9,46.1,36,66.4,24.6c2.4-1.3,4.6-2.7,6.7-4l0,0l2.1-1.4 c5.5-3.7,10-7.2,14.4-10.2l3-1.9L92.8,7l0,0c5.8-3.4,11.8-5.5,19.9-5.1c1.6,0.1,3.2,0.3,4.7,0.7l0,0c0.1,0,0.3,0.1,0.4,0.1 c0.9,0.2,1.7,0.5,2.6,0.9c14.8,5.6,25,23.2,25,23.2c-5-21.3-8.3-24.1-9.1-25C156.6,17,150.4,32.7,150.4,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014597772895977827100000011343438303282732450_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.6003,
    y1: 171.698,
    x2: 163.6003,
    y2: 177.9734,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014597772895977827100000011343438303282732450_)"
    },
    d: "M150.4,32.7c0,0,18.3-1.7,26.4,3.5 C176.9,36.2,162.8,24.8,150.4,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070819054680778863020000015364418593918738855_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.3,
    y1: 24.124,
    x2: 145.6,
    y2: 24.124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070819054680778863020000015364418593918738855_)"
    },
    d: "M145.6,36.2c0,0-10.1-24.6-27.7-24.8 c-17.6-0.2-27.6,24.9-27.6,24.9S141.6,37.6,145.6,36.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098929914987448362190000013006615162930218925_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.0614,
    y1: 107.94,
    x2: 42.7493,
    y2: 107.94,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098929914987448362190000013006615162930218925_)"
    },
    d: "M33.1,97.7c2.9,1.7,8.5,4,9.7,4.5 C38.3,100.8,34.7,98.7,33.1,97.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144308947231523847350000013208320832781747363_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.2,
    y1: 141.34,
    x2: 75.1,
    y2: 141.34,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#FF6300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144308947231523847350000013208320832781747363_)"
    },
    d: "M32.1,97l0.1,16.9c0,0-7.8-20.5-8-38.5 l0,0c5.6-13,26.7-26.4,33.5-34.6c6.7-7.9,14.9-19.6,15.3-20.2l0,0l2.1-1.4c0,0-2.1,5.4-14.8,20.4S34,58.2,30.1,70.9 C26.2,83.5,29.6,95.2,32.1,97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109014167174435959660000010046570392269413801_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.7591,
    y1: 104.4506,
    x2: 61.7591,
    y2: 200.79,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#FF8400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109014167174435959660000010046570392269413801_)"
    },
    d: "M53.8,103.2c-3.8,0.6-7.6,0-10.8-1l0,0 c-0.6-0.6-14.3-13.3-11.9-24.1C33.4,67,68.3,52.5,75.1,40C81.8,27.4,89.5,9.1,89.5,9.1l3-1.9l0.2-0.1c-5.3,4.3-7.4,17.7-16,33.6 S50.6,68.2,46.6,77.6c-3.8,9-0.1,15.7,0.3,16.3l0,0C49,101.3,53.8,103.2,53.8,103.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022550327150612421040000016639585616517314230_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6595,
    y1: 155.94,
    x2: 120.5845,
    y2: 155.94,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#FF6300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022550327150612421040000016639585616517314230_)"
    },
    d: "M117.8,2.7c1,0.2,2,0.6,2.8,0.9h-0.1 c-8-1.8-21.8,15-30.1,27.5C81.4,44.3,70.2,56,70.2,56S50.9,78.5,49.3,85.8c-1.5,7.1,9.4,15,10,15.5c-7.4-1.6-11.3-8-12.7-10.7l0,0 c-0.1-2,0.1-4.7,0.6-7.9c1.2-6.7,36.6-45.8,46.5-61c9.7-15,23.2-19,23.6-19.1l0,0C117.5,2.6,117.7,2.6,117.8,2.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002372831510086100990000017320870400477039264_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.7502,
    y1: 204.09,
    x2: 121.6345,
    y2: 204.09,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002372831510086100990000017320870400477039264_)"
    },
    d: "M121.6,4c-0.3-0.2-0.6-0.3-0.9-0.4 C121.1,3.8,121.5,4,121.6,4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065038691429469784470000012203542577491071658_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1346,
    y1: 151.59,
    x2: 183.9346,
    y2: 151.59,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#FF6300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065038691429469784470000012203542577491071658_)"
    },
    d: "M154.1,41.4c0,0,12.6,10.9,19.9,18.2 c7.3,7.3,9.9,7.1,9.9,7.1v4.5c0,0-7.1-3.8-13.1-12s-10.9-11.9-10.9-11.9L154.1,41.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160166859965379475170000009532950159242583451_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.8186,
    y1: 133.99,
    x2: 183.0666,
    y2: 133.99,
    gradientTransform: "matrix(1 0 0 -1 0 207.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#FF6300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160166859965379475170000009532950159242583451_)"
    },
    d: "M167.8,60c0,0,10.5,22.1,15.2,23.2 l-0.5,4.6c0,0-8.6-7.9-12.7-20L167.8,60z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M80.5,39.2c0,0,10.1-10.9,13.7-18.1c0,0-2.5,2.6-4.5,3.1s-4.2-0.6-4.2-0.6s-8.2,15.9-7.2,15.6 C79.2,38.9,80.5,39.2,80.5,39.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M75.1,37.7c0,0-4.9-0.8-12.5,0c0,0,7.9-8.6,10.2-13.6c0,0,6.4-0.3,9.8-2.4C82.6,21.7,78,33.1,75.1,37.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M55.1,31c0,0,2.8,4.1,4.5,4.2c1.7,0.1,9.4-11.1,9.4-11.1S59.2,29.7,55.1,31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair3);
export default __webpack_public_path__ + "static/media/Hair3.1c65207c94a064f926710181637c8398.svg";
export { ForwardRef as ReactComponent };